import type { ComponentChildren } from "preact";

interface TileProps {
  label: string;
  value: string;
  /** A second line under the value ("engine 18", "+2 temp"). */
  sub?: string | null;
  overridden?: boolean;
  /** Muted tiles: a strike that is not ready, a disabled statistic. */
  muted?: boolean;
  onTap?: (() => void) | undefined;
  title?: string;
}

/** One number on the sheet: label above, value big, tap to open its panel. At least 44 pt each way. */
export function StatTile({ label, value, sub, overridden, muted, onTap, title }: TileProps) {
  const cls = `stat${overridden ? " overridden" : ""}${muted ? " muted-tile" : ""}`;
  const inner = (
    <>
      <span class="stat-label">{label}</span>
      <span class="stat-value">{value}</span>
      {sub ? <span class="stat-derived">{sub}</span> : null}
    </>
  );
  return onTap ? (
    <button type="button" class={cls} onClick={onTap} title={title ?? `${label}: tap for the breakdown and Override`}>{inner}</button>
  ) : (
    <span class={cls} title={title}>{inner}</span>
  );
}

/** A row of tiles with a heading. */
export function TileRow({ title, children }: { title?: string; children: ComponentChildren }) {
  return (
    <div class="tile-row">
      {title && <h3 class="row-title">{title}</h3>}
      <div class="stats">{children}</div>
    </div>
  );
}

/** A tappable list row: label left, detail right, at least 44 pt tall. */
export function ListRow({ onTap, children, class: extra, disabled }: { onTap?: () => void; children: ComponentChildren; class?: string; disabled?: boolean }) {
  return onTap ? (
    <button type="button" class={`list-row${extra ? ` ${extra}` : ""}`} onClick={onTap} disabled={disabled}>{children}</button>
  ) : (
    <div class={`list-row${extra ? ` ${extra}` : ""}`}>{children}</div>
  );
}
